//API functions
import axios from 'axios';

// Filter report data based on search input
// export async function findTicket(connectionURL, tkt) {
//   try {
// const response = await axios.get(`${connectionURL}/reports/findTicket/${tkt}`);
// if (response.data && response.data.length > 0) {
//   targetItem = response.data.map((item) => ({
//     Ticket: item.Ticket,
//     SectionName: item.SectionName,
//     LaneNum: item.LaneNum,
//     SpaceNum: item.SpaceNum,
//     DateTimeIn: item.DateTimeIn,
//     DateTimeOut: item.DateTimeOut,
//     CarMake: item.CarMake,
//     CarColor: item.CarColor,
//     LicensePlate: item.LicensePlate,
//   }));
//   console.log('truthy');
//   return response.data[0]?.Ticket;

//   //   setReportData(targetItem);
//   //   reportDataRef.current = targetItem;
// } else {
//   console.log('Ticket 0');
//   return null;
// }

//   } catch (error) {
//     console.log('Error finding ticket:', tkt, error);
//   }
// }

// export async function findTicket(connectionURL, tkt) {
//   try {
//     const response = await axios.get(`${connectionURL}/reports/findTicket/${tkt}`);
//     console.log(response.data.length, 'length');

//     if (response.data.length === 0) {
//       console.log('Ticket 0');
//       return null;
//     }

//     if (response.status === 404) {
//       console.log('Ticket 0');
//       return null;
//     }

//     return response.data[0].Ticket;
//   } catch (error) {
//     console.log('Error finding ticket:', tkt, error);
//     return null;
//   }
// }

export async function findTicket(connectionURL, tkt) {
  try {
    const response = await axios.get(`${connectionURL}/reports/findTicket/${tkt}`);

    if (!response.data || response.data.length === 0) {
      console.log('Ticket 0');
      return null;
    }

    return response.data[0].Ticket;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      console.log('Ticket 0');
      return null;
    }

    console.log('Error finding ticket:', tkt, error);
    return null;
  }
}

// Display ticket information when either a PARCS ticket or locator ticket is scanned
export async function showTicketInformation(connectionURL, tkt) {
  try {
    const response = await axios.get(`${connectionURL}/daily/displayTkt/${tkt}`);

    if (!response.data || response.data.length === 0) {
      console.log('Ticket 0');
      return null;
    }
    console.log(response.data[0].Ticket, 'Data');
    return response.data[0].Ticket;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      console.log('Ticket 0');
      return null;
    }

    console.log('Error finding ticket:', tkt, error);
    return null;
  }
}

// Post checkouts to daily checkouts table
export async function postCheckOut(
  connectionURL,
  ticketNumber,
  locator,
  checkOutDatabaseDate,
  checkIn,
  sectionInfo,
  laneInfo,
  status,
  spotInfo,
  stayHrsRef,
  stayMinsRef,
  empCard,
) {
  // hrsRef = calculateTimeDifference(checkIn, new Date()).hours;
  // minRef = calculateTimeDifference(checkIn, new Date()).minutes;
  try {
    const response = await axios.post(`${connectionURL}/checkOuts/checkOutVehicle`, {
      Ticket: ticketNumber || 0,
      Locator: locator || 0,
      // convert to SQL datetime format
      CheckOutDateTime: checkOutDatabaseDate,
      // Convert from local date and time to ISO format for SQL
      CheckIn: checkIn,
      SectionName: sectionInfo,
      LaneNum: laneInfo,
      Status: status,
      SpaceNum: spotInfo,
      StayHr: stayHrsRef || 0,
      StayMin: stayMinsRef || 0,
      CardNum: empCard || 0,
    });
    if (response.status === 200) {
      console.log(
        'Check out posted successfully:',
        new Date(checkIn).toISOString().slice(0, 19).replace('T', ' '),
        checkIn,
      );
    }
  } catch (error) {
    console.error('Error posting check out:', error);
  }
}

export async function getCheckoutTicketData(connectionURL, ticketNumber) {
  // Pull ticket info from api and populate ticket details page

  try {
    const response = await axios.get(`${connectionURL}/daily/enteredTicket/${ticketNumber}`);
    if (response.data.length > 0) {
      console.log(response.data, 'Check outs array');
      return response.data;

      // setTicketNumber(response.data[0].Ticket);
      // setLocator(response.data[0].Locator);
      // setCarInfo(response.data[0].CarMake);
      // setColorInfo(response.data[0].CarColor);
      // setLicenseInfo(response.data[0].LicensePlate);
      // setSectionInfo(response.data[0].SectionName);
      // setLaneInfo(response.data[0].LaneNum);
      // setSpotInfo(response.data[0].SpaceNum);
      // setCheckIn(new Date(response.data[0].TicketAdded).toLocaleString());
    }
    // } else {
    //   toast.error(
    //     <div>
    //       <h3>Ticket Not Found</h3>
    //       <p>No active ticket found for ticket number {ticketNumber}.</p>
    //       <p>To try again, click 'Close' to exit.</p>
    //       <button
    //         style={{
    //           marginTop: '5px',
    //           padding: '10px',
    //           backgroundColor: '#007bff',
    //           color: 'white',
    //           border: 'none',
    //           borderRadius: '10px',
    //           cursor: 'pointer',
    //         }}
    //         onClick={() => {
    //           toast.dismiss();
    //           setTimeout(() => {
    //             setTicketNumber('');
    //           }, 500);
    //         }}
    //       >
    //         Close
    //       </button>
    //     </div>,
    //     { hideProgressBar: true, closeOnClick: false, pauseOnHover: false, autoClose: false },
    //   );
    // }
  } catch (error) {
    console.error('Error fetching ticket info:', error);
  }
}

// Delete ticket from spaces table on check out
export async function deleteTicketLocation(connectionURL, ticketNumber) {
  try {
    const response = await axios.delete(`${connectionURL}/spaces/deleteCarLocation/${ticketNumber}`);
    if (response.data) {
      console.log('Ticket location deleted successfully');
    } else {
      console.error('Error deleting ticket location');
    }
  } catch (error) {
    console.error('Error deleting ticket location:', error);
  }
}

export async function showSectionsAndSpaces(connectionURL) {
  try {
    const result = await axios.get(`${connectionURL}/spaces/sectionSpacesRange`);
    if (!result.data || result.data.length === 0) {
      return;
    }

    if (result.data && result.data.length > 0) {
      return result.data;
    }
  } catch (error) {
    console.log('Error retrieving spaces and sections', error);
  }
}

// insert tickets that were not checked in
export async function insertUnCheckedInTickets(connectionURL, ticketNumber, scannedDate) {
  try {
    const response = await axios.post(`${connectionURL}/daily/insertUnCheckedInTicket`, {
      Ticket: ticketNumber,
      ScannedDateTime: scannedDate,
    });
    if (response.status === 200) {
      console.log('Un-checked in ticket inserted successfully');
    } else {
      console.error('Error inserting un-checked in ticket');
    }
  } catch (error) {
    console.error('Error inserting un-checked in ticket:', error);
  }
}

// Count of unchecked in tickets
export async function countUnCheckedInTickets(connectionURL) {
  try {
    const response = await axios.get(`${connectionURL}/reports/unCheckedInTicketsCount`);

    if (response.data) {
      console.log('Un-checked in tickets count:', response.data);
      return response.data;
    }
  } catch (error) {
    console.error('Error counting un-checked in tickets:', error);
  }
}

// Find if the omitted ticket has been added. If so, return true
export async function findOmittedTicket(connectionURL, ticket) {
  try {
    const response = await axios.get(`${connectionURL}/daily/findUncheckedInTicket/${ticket}`);
    if (response.data.length > 0) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error('Error finding omitted ticket', error);
  }
}

export async function fetchTicketIssuedCount(connectionURL) {
  try {
    const response = await axios.get(`${connectionURL}/reports/ticketsIssuedToday`);
    return response.data || 0;
  } catch (error) {
    console.error('Error fetching ticket issued count:', error);
  }
}
// Checkouts count today for activities table
export async function fetchCheckOutsCount(connectionURL) {
  try {
    const response = await axios.get(`${connectionURL}/checkOuts/checkOutsCountCurrentDay`);
    // Assuming response.data contains the count
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching checkouts count:', error);
  }
}

//   Check outs count within the current hour
export async function fetchCheckOutsCountThisHour(connectionURL) {
  try {
    const response = await axios.get(`${connectionURL}/checkOuts/checkOutsCountCurrentHour`);
    // Assuming response.data contains the count
    if (response.data) {
      return response.data || 0;
    }
  } catch (error) {
    console.error('Error fetching checkouts count this hour:', error);
  }
}

//   Check ins count within the current hour
export async function fetchCheckInsCountThisHour(connectionURL) {
  try {
    const response = await axios.get(`${connectionURL}/checkOuts/checkInsCountCurrentHour`);
    // Assuming response.data contains the count
    if (response.data) {
      return response.data;
    } else {
      return 0;
    }
  } catch (error) {
    console.error('Error fetching check ins count this hour:', error);
  }
}

// Calculate average stay duration current day
export async function fetchAvgStayDuration(connectionURL) {
  try {
    const response = await axios.get(`${connectionURL}/checkOuts/averageStayDurationToday`);
    // Assuming response.data contains the average stay duration
    if (response.data) {
      return {
        hours: response.data.averageStay.hours,
        minutes: response.data.averageStay.minutes,
      };
    }
  } catch (error) {
    console.error('Error fetching average stay duration:', error);
  }
}

// Fetch parking facility occupancy data
export async function fetchOccupancyData(connectionURL) {
  try {
    const response = await axios.get(`${connectionURL}/checkOuts/capacityStats`);
    // Process the occupancy data as needed
    if (response.data) {
      // Example: Log the occupancy data
      console.log('Occupancy Data:', response.data);
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching occupancy data:', error);
  }
}

// Function to handle manual checkouts count
export async function fetchManualCheckOutsCount(connectionURL) {
  try {
    const response = await axios.get(`${connectionURL}/checkOuts/manualCheckOutsCountToday`);
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching manual checkouts count:', error);
  }
}

// Compares the number of tickets issued on current day to the day before
export async function compareTicketsIssuedTodayToYesterday(connectionURL) {
  try {
    const response = await axios.get(`${connectionURL}/daily/compareTicketsIssued`);
    if (response) {
      console.log(response);
      return response.data;
    }
  } catch (error) {
    console.error('Error comparing issued tickets', error);
  }
}

// Compares current day number of check outs to another period
export async function compareCheckOutsTodayToYesterday(connectionURL) {
  try {
    const response = await axios.get(`${connectionURL}/daily/compareTicketsExited`);
    if (response) {
      return response.data;
    }
  } catch (error) {
    console.error('Error comparing check outs', error);
  }
}

// Compares current day omitted tickets to another period
export async function compareOmittedTicketsTodayToYesterday(connectionURL) {
  try {
    const response = await axios.get(`${connectionURL}/daily/compareOmittedTickets`);
    if (response) {
      return response.data;
    }
  } catch (error) {
    console.error('Error comparing omitted tickets', error);
  }
}

// Compare current day manually closed tickets to another period
export async function compareManualTicketsTodayToYesterday(connectionURL) {
  try {
    const response = await axios.get(`${connectionURL}/daily/compareManualTicket`);
    if (response) {
      return response.data;
    }
  } catch (error) {
    console.error('Error comparing manually closed tickets', error);
  }
}

// Compare current day issued tickets to the same day last week
export async function compareTodayIssuedTktsToSDLW(connectioURL) {
  try {
    const response = await axios.get(`${connectioURL}/daily/sameDayLastWeekCompareTktsIn`);
    if (response) {
      return response.data;
    }
  } catch (error) {
    console.error('Error comparing issued tickets today to same day last week', error);
  }
}

// Compare the number of check outs to the same day last week
export async function compareTodayCheckOutsToSDLW(connectionURL) {
  try {
    const response = await axios.get(`${connectionURL}/daily/sameDayLastWeekCompareTktsOut`);
    if (response) {
      return response.data;
    }
  } catch (error) {
    console.error('Error comparing today check outs today to same day last week', error);
  }
}

// Find ticket in occupancy table to determine its current location in the parking facility
export async function findTicketLocation(connectionURL, ticket) {
  try {
    const response = await axios.get(`${connectionURL}/spaces/carLocation/${ticket}`);
    if (response.data.length > 0) {
      console.log(response.data[0], 'car location');
      return response.data[0];
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error finding ticket location', error);
  }
}

// Function that will fetch checkout ticked information from checkout table
export async function fetchTicketFromCheckoutTbl(connectionURL, exitingTkt) {
  try {
    const response = await axios.get(`${connectionURL}/checkOuts/findTicketInCheckoutTbl/${exitingTkt}`);
    if (response.status === 200 && response.data.length > 0) {
      return response.data;
    }
  } catch (error) {
    console.log('No ticket found in checkout table', error);
  }
}

// Find ticket in occupancy table to determine its current location in the parking facility
export async function findLocatorLocation(connectionURL, locator) {
  try {
    const response = await axios.get(`${connectionURL}/spaces/carLocationByLocator/${locator}`);
    if (response.data.length > 0) {
      console.log(response.data[0], 'car location');
      return response.data[0];
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error finding ticket location', error);
  }
}

// List the space numbers that are currently occupied in a specific section and lane
export async function listOccupiedSpaces(connectionURL, section, lane, ticket) {
  try {
    const response = await axios.get(`${connectionURL}/spaces/occupiedSpacesInfo/${section}&${lane}&${ticket}`);
    if (response.data) {
      return response.data.map((item) => ({
        Ticket: item.Ticket,
        Locator: item.Locator,
        SectionName: item.SectionName,
        LaneNum: item.LaneNum,
        SpaceNum: item.SpaceNum,
      }));
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error listing occupied spaces', error);
  }
}

// get all tickets marked to be moved
export async function getTicketsToBeMoved(connectionURL) {
  try {
    const response = await axios.get(`${connectionURL}/spaces/getTicketsToBeMoved`);
    if (response.data.length > 0 && response.status === 200) {
      console.log('get ticket to be moved', response.data);
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error getting tickets to move', error);
  }
}

// Insert tickets marked to move to a new location
export async function insertTicketToMove(connectionURL, t, locator, section, lane, space) {
  console.log('insertTicketToMove called');
  try {
    const response = await axios.post(`${connectionURL}/spaces/insertMovedTicket`, {
      Ticket: t,
      Locator: locator,
      SectionName: section,
      LaneNum: lane,
      SpaceNum: space,
      IsMoved: 0,
    });
    if (response.status === 200) {
      console.log('Moved ticket inserted successfully');
    } else {
      console.error('Error inserting moved ticket');
    }
  } catch (error) {
    console.log('Error inserting ticket to move', error);
  }
}

// Delete moved ticket
export async function deleteMovedTicket(connectionURL, deletedTkt) {
  try {
    const response = await axios.delete(`${connectionURL}/spaces/deleteMovedTicket/${deletedTkt}`);
    if (response.status === 200) {
      console.log('Deleted moved ticket successfully');
    } else {
      console.error('Error deleting moved ticket');
    }
  } catch (err) {
    console.log('Error deleting moved ticket', err);
  }
}

// Find ticket number in occupied space using section, lane and space numbers
// identify the ticket. This is used to display the ticket number in the occupied space.
export async function findTicketNumberInOccupiedSpace(connectionURL, section, lane, space) {
  try {
    const response = await axios.get(`${connectionURL}/spaces/findTicketInSpace/${section}&${lane}&${space}`);
    if (response.status === 200 && response.data.length > 0) {
      return response.data[0];
    } else {
      console.log('No ticket found in occupied space');
    }
  } catch (error) {
    console.log('Error in fetching ticket from occupied space', error);
  }
}

// Check if employee card number exists
export async function doesEmployeeCardExist(connectionURL, cardNum) {
  try {
    const response = await axios.get(`${connectionURL}/empCard/isEmpCardValid/${cardNum}`);
    if (response.data && response.status === 200) {
      return response.data[0];
    }
    return null;
  } catch (error) {
    console.log('Employee card does not found', error);
  }
}

// Check if ticket number exists in the daily checkouts table,
// ticket did not exit and was checked out today.
// This is used so that the dispatcher can verify the ticket's validity and
// scan the checkout receipt and hand to parking attendant.
export async function doesTicketExistInDailyCheckOuts(connectionURL, ticketNum) {
  try {
    const response = await axios.get(`${connectionURL}/checkouts/findTicketNotExited/${ticketNum}`);
    if (response.data && response.status === 200) {
      console.log('Ticket found in daily checkouts:', response.data.exists, response.data.ticket);
      return { exists: response.data.exists, ticket: response.data.ticket };
    } else {
      console.log('Ticket not found in daily checkouts');
      return null;
    }
  } catch (error) {
    console.log('Error checking ticket in daily checkouts', error);
  }
}

// Function to update user mode in the database
export async function updateUserMode(connectionURL, userId, newMode) {
  try {
    const response = await axios.patch(`${connectionURL}/usersLogin/updateUserMode/${userId}`, {
      UserMode: newMode,
    });
    if (response.status === 200) {
      console.log('User mode updated successfully');
    } else {
      console.error('Error updating user mode');
    }
  } catch (error) {
    console.log('Error updating user mode', error);
  }
}

// Function to fetch the current user mode from the database
export async function fetchUserMode(connectionURL, user) {
  try {
    const response = await axios.get(`${connectionURL}/usersLogin/getUserModeByUserName/${user}`);
    if (response.status === 200) {
      console.log('User mode fetched successfully:', response.data.UserMode);
      return response.data.UserMode;
    }
  } catch (error) {
    console.log('Error fetching user mode', error);
  }
}

// Function to update the check out record with the employee card number and attendant name
// used for check out
export async function updateCheckOutWithEmpCard(connectionURL, ticketNumber, empCard, empName, checkOutStatus) {
  try {
    const response = await axios.patch(`${connectionURL}/empCard/updateCheckOutCardNumber/${ticketNumber}`, {
      CardNum: empCard,
      FullName: empName,
      Status: checkOutStatus,
    });
    if (response.status === 200) {
      console.log('Check out updated with employee card number successfully');
    } else {
      console.error('Error updating check out with employee card number');
    }
  } catch (error) {
    console.log('Error updating check out with employee card number', error);
  }
}

// Function that identifies the attendant name using the card number
export async function findAttendantName(connectionURL, card) {
  try {
    const response = await axios.get(`${connectionURL}/empCard/fetchEmployeeName/${card}`);
    if (response.status === 200 && response.data.length > 0) {
      return response.data[0];
    } else {
      return null;
    }
  } catch (error) {
    console.log('Attendant name was not found', error);
  }
}

export async function updateTargetTicket(connectionURL, exitingTkt, blockingTkt, lane) {
  try {
    const result = await axios.patch(`${connectionURL}/spaces/updateTargetTicket/${blockingTkt}&${lane}`, {
      TargetTicket: exitingTkt,
      Ticket: blockingTkt,
      LaneNum: lane,
    });

    if (result.status === 200) {
      console.log('Target ticket number updated');
    }
  } catch (error) {
    console.log('Error updating target ticket', error);
  }
}

// Function that retrieves the blocking spaces based on having the section and space
export async function getBlockingSpaces(connectionURL, section, space) {
  try {
    const response = await axios.get(`${connectionURL}/spaces/fetchBlockingSpaces/${section}&${space}`);
    if (response.status === 200 && response.data.length > 0) {
      return response.data[0].BlockingSpaces;
    }
  } catch (error) {
    console.log('Error getting blocking spaces', error);
  }
}

// Function to retrieve the list of blocking tickets after the exiting ticket is known
export async function getNewBlockingTicketsList(connectionURL, exitingTkt) {
  try {
    const response = await axios.get(`${connectionURL}/spaces/getNewListOfTicketsToBeMoved/${exitingTkt}`);
    if (response.status === 200 && response.data.length > 0) {
      return response.data;
    }
  } catch (error) {
    console.log('New blocking tickets list not found', error);
  }
}

// Function to pull open tickets data
export async function fetchAllOpenTickets(connectionURl) {
  try {
    const response = await axios.get(`${connectionURl}/reports/allOpenTicketsReport`);

    if (response.data && response.data.length > 0) {
      console.log('Fetched open tickets data:', response.data);
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching open tickets data:', error);
  }
}

// Update tblDailyActivity with manually closed tickets date and time out
export async function updateDailyActivityWithManualClose(connectionURL, ticketsToClose) {
  // Logic to update daily activity with manual close
  try {
    for (const targetTicket of ticketsToClose.slice(0, 4)) {
      const response = await axios.patch(
        `${connectionURL}/checkouts/manualsToDailyActivityTable/${targetTicket}`,
        {
          headers: { 'Content-Type': 'application/json' },
          DateTimeOut: new Date().toISOString().slice(0, 19).replace('T', ' '),
        },
      );
      if (response.status === 200) {
        console.log(`Daily activity updated for ticket: ${targetTicket}`);
      }
      // After updating the daily activity, we can remove the ticket from the ticketToCloseRef
      // to keep it updated with only the tickets that are still open and need to be closed.
    }
  } catch (error) {
    console.error('Error updating daily activity with manual close:', error);
  }
}

// Delete function to remove manually closed tickets from tblOccupiedSpaces
export async function deleteManuallyClosedTickets(connectionURL, ticketToClose) {
  try {
    for (const targetTicket of ticketToClose) {
      const response = await axios.delete(`${connectionURL}/checkouts/deleteManualOpenTicket/${targetTicket}`, {
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.status === 200) {
        console.log(`Manually closed ticket deleted: ${targetTicket}`);
      }
    }
  } catch (error) {
    console.error('Error deleting manually closed tickets:', error);
  }
}

// Insert update manually closed ticket function here
export async function postManuallyClosedTickets(connectionURL, ticketsToClose) {
  // Use payload variable to send data to backend to insert into manually closed tickets table
  const payload = ticketsToClose.map((ticket, k) => ({
    Ticket: ticket,
  }));
  console.log('Payload to be sent:', {
    payload,
  });
  if (payload.length === 0) {
    alert('No tickets selected for manual close. Please select at least one ticket.');
    return;
  }

  try {
    // Use for loop to iterate through payload and send each ticket as a separate POST request to backend
    // This is necessary because the backend endpoint is designed to handle one ticket at a time,
    //  and sending multiple tickets in a single request would require additional handling
    // on the backend to iterate through the array of tickets and insert them individually.
    // Even though this approach results in multiple requests being sent to the backend,
    // it simplifies the implementation and ensures that each ticket is processed correctly
    // without requiring changes to the existing backend logic.
    // It is possible that more than one ticket is checked tickets could be selected,
    // which make the array length more then and therefore we need a loop
    // to send each ticket separately to the backend.
    for (const item of payload) {
      console.log('Sending item:', item);
      const response = await axios.post(`${connectionURL}/daily/insertManuallyClosedTicket`, item, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.status !== 200) {
        console.log('Error inserting manually closed ticket:', response.statusText);
        return;
      }
    }
  } catch (error) {
    console.error('Error adding manually closed ticket:', error);
  }
}

// Update tblCheckOuts by making a PATCH request to the server
//  with the ticket number and new status.
// This function is used to update the status of a ticket in the database.
// When ticket is scanned, the status is updated to "Exited"
// and the time is recorded in the database.
export async function updateTicketStatus(connectionURL, ticketNumber) {
  try {
    const response = await axios.patch(`${connectionURL}/checkOuts/updateExitTime/${ticketNumber}`, {
      Ticket: ticketNumber,
    });
    if (response.status !== 200) {
      throw new Error(`Failed to update ticket status: ${response.statusText}`);
    }
    return response.data;
  } catch (error) {
    console.error('Error updating ticket status:', error);
    return null;
  }
}
